import { render } from "./J2001.vue?vue&type=template&id=bcc5a996"
import script from "./J2001.vue?vue&type=script&lang=js"
export * from "./J2001.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Git-Local\\afm.git - Kopie\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__